export function OutlineFileXlsIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4577 15.2264C20.3714 15.1976 20.2802 15.1736 20.189 15.1497C19.7859 15.0489 19.3876 14.9961 18.9845 14.9961C18.4807 14.9961 18.068 15.0633 17.7416 15.2024C17.4153 15.3416 17.1706 15.524 17.0122 15.7495C16.8539 15.975 16.7771 16.2294 16.7771 16.5125C16.7771 16.7956 16.8539 17.0116 17.0026 17.1843C17.1514 17.3571 17.3529 17.501 17.5977 17.6066C17.8424 17.717 18.1112 17.8082 18.4087 17.8897C18.7062 17.9713 18.9989 18.0481 19.2964 18.1249C19.594 18.2017 19.8627 18.2976 20.1074 18.408C20.3522 18.5184 20.5489 18.6623 20.7025 18.8351C20.856 19.0126 20.928 19.2382 20.928 19.5117C20.928 19.7852 20.8464 20.03 20.6881 20.2555C20.5297 20.4763 20.285 20.6586 19.9587 20.793C19.6324 20.9273 19.2197 20.9945 18.711 20.9945C18.2023 20.9945 17.6985 20.9226 17.2042 20.7786C17.0698 20.7402 16.9403 20.697 16.8203 20.6538"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5244 15.002V20.7077H13.9315"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.37646 21.0004L3 15.002"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 21.0004L7.37646 15.002"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9655 12.0025V8.83048C18.9655 8.29782 18.7544 7.79395 18.3801 7.41485L14.5507 3.58545C14.1764 3.21115 13.6677 3 13.135 3H6.90147C5.79776 3 4.90039 3.89737 4.90039 5.00108V11.9977"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M12.967 3.00391V7.28919C12.967 8.23454 13.7348 9.00234 14.6802 9.00234H18.9655"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
